import { IDataProvider } from "@/store";
import { IEntityApprovalRequest } from "@/types/common/entityApproval/EntityApproval";

export interface IEntityApprovalState {
  dataProvider: IDataProvider<IEntityApprovalRequest>;
}

export const state: IEntityApprovalState = {
  dataProvider: {
    items: [],
    pager: {
      buttonsToShow: 3,
      currentPage: 1,
      endPage: 1,
      startPage: 1,
      totalPages: 1,
    },
  },
};
